var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{attrs:{"label":_vm.$t('lines.gridHeaderEdit.fieldLabel'),"rules":_vm.rules},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}})
}
var staticRenderFns = []

export { render, staticRenderFns }